export function toKebabCase(value) {
    return value.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`);
}

export function getFinalDataValue($element, propertyName) {
    const attrName = `data-final-${toKebabCase(propertyName)}`;
    const rawValue = $element.attr(attrName);

    if (rawValue === undefined) return undefined;

    const trimmedValue = String(rawValue).trim();
    if (!trimmedValue) return undefined;

    if (/^-?\d+(\.\d+)?$/.test(trimmedValue)) {
        return parseFloat(trimmedValue);
    }

    return trimmedValue;
}

export function getFinalAnimationProps($element, defaultProps) {
    const finalProps = {};

    Object.entries(defaultProps).forEach(([propertyName, defaultValue]) => {
        const dataValue = getFinalDataValue($element, propertyName);
        finalProps[propertyName] = dataValue !== undefined ? dataValue : defaultValue;
    });

    [
        "left",
        "right",
        "top",
        "bottom",
        "width",
        "height",
        "x",
        "y",
        "xPercent",
        "yPercent",
        "rotation",
        "opacity",
        "scale",
    ].forEach((propertyName) => {
        if (propertyName in finalProps) return;

        const dataValue = getFinalDataValue($element, propertyName);
        if (dataValue !== undefined) {
            finalProps[propertyName] = dataValue;
        }
    });

    return finalProps;
}

export function getExpandingImageFinalAnimationProps($element, defaultProps) {
    const finalProps = getFinalAnimationProps($element, defaultProps);
    const hasLeft = getFinalDataValue($element, "left") !== undefined;
    const hasRight = getFinalDataValue($element, "right") !== undefined;
    const hasTop = getFinalDataValue($element, "top") !== undefined;
    const hasBottom = getFinalDataValue($element, "bottom") !== undefined;
    const hasXPercent = getFinalDataValue($element, "xPercent") !== undefined;
    const hasYPercent = getFinalDataValue($element, "yPercent") !== undefined;

    if (hasBottom && !hasTop) {
        finalProps.top = "auto";
    }

    if (hasRight && !hasLeft) {
        finalProps.left = "auto";
    }

    if ((hasLeft || hasRight) && !hasXPercent) {
        finalProps.xPercent = 0;
    }

    if ((hasTop || hasBottom) && !hasYPercent) {
        finalProps.yPercent = 0;
    }

    return finalProps;
}
